import ActionTypes from "../../enums/ActionTypes"
import { createGenericRequestReducer } from "../api"

export default createGenericRequestReducer(ActionTypes.BASEDATA_PUBLIC_HOLIDAYS_LIST)
